/** The application status provided by unit (only Draft is a Covercy status).
 * Notice: This enum must match the server side enum.
 */
export enum UnitApplicationStatus {
  /** The application was denied. A Customer resource will not be created. */
  Denied = -1,
  /** Covercy status - A draft was saved. Nothing was sent to Unit yet. */
  Draft = 0,
  /** The application was approved. A Customer resource was created. */
  Approved = 1,
  /** Certain documents are required for the process to continue. */
  AwaitingDocuments = 2,
  /** The application is pending review by Unit. */
  PendingReview = 3,
  /** The application is being evaluated asynchronously and a result should be available shortly.  */
  Pending = 4,
  /** The application was canceled. A Customer resource will not be created. */
  Canceled = 5
}

// tslint:disable-next-line:no-namespace
export namespace UnitApplicationStatus {
  export function toString(areaUnit: UnitApplicationStatus): string {
    switch (areaUnit) {
      case UnitApplicationStatus.Denied:
        return 'Denied';
      case UnitApplicationStatus.Draft:
        return 'Draft';
      case UnitApplicationStatus.Approved:
        return 'Approved';
      case UnitApplicationStatus.AwaitingDocuments:
        return 'Documents needed';
      case UnitApplicationStatus.PendingReview:
        return 'Pending review';
      case UnitApplicationStatus.Pending:
        return 'Pending';
      case UnitApplicationStatus.Canceled:
        return 'Canceled';
      default:
        return null;
    }
  }

  export function listAll() {
    return [
      UnitApplicationStatus.Denied,
      UnitApplicationStatus.Draft,
      UnitApplicationStatus.Approved,
      UnitApplicationStatus.AwaitingDocuments,
      UnitApplicationStatus.PendingReview,
      UnitApplicationStatus.Pending,
      UnitApplicationStatus.Canceled,
    ];
  }

  export function parse(str: string): UnitApplicationStatus {
    return UnitApplicationStatus[str];
  }
}

export default UnitApplicationStatus;
